/**
 *  @class
 *  @function Cart
 */
class Cart {

  constructor() {
    this.container = document.getElementById('Cart');
    this.isProcessing = false;
    this.setupEventListeners();
  }
  onChange(event) {
    if (event.target.type == 'number') {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    } else if (event.target.getAttribute('id') == 'CartSpecialInstructions') {
      this.saveNotes();
    }
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('CartSpecialInstructions').value
      })
    });
  }
  setupEventListeners() {
    if (this._removeHandlerBound) return;
    this._removeHandlerBound = true;
    
    this.container.addEventListener('click', (event) => {
      const removeButton = event.target.closest('.remove');
      if (removeButton) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        if (this.isProcessing) {
          return;
        }
        
        if (removeButton.classList.contains('loading') || removeButton.hasAttribute('disabled')) {
          return;
        }
        
        const lineIndex = removeButton.getAttribute('data-index');
        if (!lineIndex) {
          return;
        }
        
        const currentLineIndex = String(lineIndex).trim();
        if (!currentLineIndex) {
          return;
        }
        
        removeButton.classList.add('loading');
        this.isProcessing = true;
        this.updateQuantity(currentLineIndex, '0');
      }
    }, { once: false, passive: false });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.termsCheckbox();
  }
  getSectionsToRender() {
    return [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  displayErrors(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      lineItemError.removeAttribute('hidden');
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
      this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
    }
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  updateQuantity(line, quantity) {
    const lineNumber = parseInt(line, 10);
    if (!lineNumber || isNaN(lineNumber)) {
      console.error('Invalid line number:', line);
      this.isProcessing = false;
      return;
    }

    this.container.classList.add('cart-disabled');
    if (lineNumber) {
      const cartItem = this.container.querySelector(`#CartItem-${lineNumber}`);
      if (cartItem) {
        cartItem.classList.add('loading');
      }
    }

    const body = JSON.stringify({
      line: lineNumber,
      quantity: parseInt(quantity, 10),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);


        if (parsedState.errors) {
          this.displayErrors(lineNumber, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          const removeButtons = this.container.querySelectorAll('.remove');
          removeButtons.forEach(btn => btn.classList.remove('loading'));
          this.isProcessing = false;
          return;
        }

        this.renderContents(parsedState, lineNumber);

        this.container.classList.remove('cart-disabled');
        this.isProcessing = false;

        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
        this.container.classList.remove('cart-disabled');
        const removeButtons = this.container.querySelectorAll('.remove');
        removeButtons.forEach(btn => btn.classList.remove('loading'));
        this.isProcessing = false;
      });
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartTerms'),
      checkout_button = this.container.querySelector('.button.checkout-button');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function(e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  renderContents(parsedState, line) {
    this.getSectionsToRender().forEach((section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

      if (line && this.container.querySelector(`#CartItem-${line}`)) {
        this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
      }
      this.termsCheckbox();
    }));
  }
}
window.addEventListener('load', () => {
  if (typeof Cart !== 'undefined') {
    new Cart();
  }
});